module.exports = __webpack_public_path__ + "848efae0c27ad352608cf375745c5126.pdf";